import React from "react";
import { Button, Card } from "antd";
import { withRouter } from "react-router-dom";
import {
  dummySpeakerData,
  dummyEventsData,
  dummyTeamData,
} from "./dummyPageData";
import OSWBLogo from "../../micro/OSWB-Logo.png";
import ScrollableCardCmp from "./ScrollableCardCmp";
import "../new_login_page/loginPage.css";
class PublicSignIn extends React.Component {
  constructor(props) {
    super(props);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.redirectToSchedulePage = this.redirectToSchedulePage.bind(this);
  }
  state = {
    phone: "",
  };
  // Function to handle sign in
  handleSignIn() {
    this.props.history.push("/conference");
  }
  // Function to redirect to /schedule route
  redirectToSchedulePage() {
    this.props.history.push("/schedule");
  }

  // Render function to display the landing page
  render() {
    return (
      <div className="main-container">
        <div className="hero-section">
          <img src={OSWBLogo} alt="OSWB Logo" />
          <h1>Annual Conference 2023</h1>
          <h2>Hosted by the Ophthalmological Society of West Bengal</h2>
        </div>
        <div className="venue-date-section">
          <div className="title">Venue & Dates</div>
          <div className="sub-text">OSWB Annual Conference, 2023</div>
          <div className="sub-text">
            Biswa Bangla Convention Centre, Kolkata
          </div>
          <div className="sub-text">December 15 - 17, 2023</div>
        </div>
        <iframe
          title="venue-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50732.62519968577!2d88.43964551651861!3d22.585134674911913!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027533fd17b983%3A0xb09288789f2f7388!2sBiswa%20Bangla%20Convention%20Centre!5e0!3m2!1sen!2sin!4v1702303592828!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: "0" }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        <div className="login-section">
          <Button
            type="primary"
            style={{
              backgroundColor: "#FE6B8B",
              borderColor: "#FE6B8B",
              fontSize: "20px",
              fontWeight: "600",
              height: "40px",
            }}
            onClick={this.handleSignIn}
          >
            Delegate Login
          </Button>
          <Button
            type="primary"
            style={{
              backgroundColor: "#FE6B8B",
              borderColor: "#FE6B8B",
              fontSize: "20px",
              fontWeight: "600",
              height: "40px",
            }}
            onClick={this.redirectToSchedulePage}
          >
            Conference Schedule
          </Button>
        </div>

        <ScrollableCardCmp title={"Speakers"}>
          {dummySpeakerData.map(({ image_url, name, title }) => (
            <div className="scroll-card">
              <img src={image_url} alt="speaker-img" />
              <div className="title">{name}</div>
              <div className="sub-text">{title}</div>
            </div>
          ))}
        </ScrollableCardCmp>
        <div className="events-section">
          <h1>{dummyEventsData.title}</h1>
          <div className="section-wrap">
            {dummyEventsData.iterableDataList.map(({ event_name, date }) => (
              <div className="scroll-card">
                <div className="title">{event_name}</div>
                <div className="sub-text">{date}</div>
              </div>
            ))}
          </div>
        </div>
        <ScrollableCardCmp title={dummyTeamData.title}>
          {dummyTeamData.iterableDataList.map(({ image_url, name, role }) => (
            <div className="scroll-card">
              <img src={image_url} alt="" />
              <div className="title">{name}</div>
              <div className="sub-text">{role}</div>
            </div>
          ))}
        </ScrollableCardCmp>
      </div>
    );
  }
}

export default withRouter(PublicSignIn);
